import CalendarDialogShiftContainer from 'components/shift-schedule/calendar-dialog-shift-container/CalendarDialogShiftContainer';
import { isValid, parseISO } from 'date-fns';
import { RouteConfig, Route as RouteType } from 'vue-router';
import DetailsContainer from './details/DetailsContainer';
import Employees from './employees/Employees';
import Evaluations from './evaluations/Evaluations';
import JoinShift from './join-shift/JoinShift';
import LeaveShift from './leave-shift/LeaveShift';
import Paygrades from './paygrades/Paygrades';
import ReplaceRequests from './replace-requests/ReplaceRequests';

export enum Route {
  ROOT = 'shiftDialog',
  DIALOG_NEW = 'shiftDialogNew',
  TAB_PAYGRADES = 'shiftDialogPaygrades',
  TAB_EMPLOYEES = 'shiftDialogEmployees',
  TAB_JOIN_SHIFT = 'shiftDialogJoinShift',
  TAB_LEAVE_SHIFT = 'shiftDialogLeaveShift',
  TAB_REPLACE_REQUESTS = 'shiftDialogReplaceRequests',
  TAB_EVALUATION = 'shiftDialogEvaluation',
}

export const propsInjectorDialogNew = (route: RouteType) => {
  const startsAt = Array.isArray(route.query.startsAt)
    ? parseISO(route.query.startsAt[0] || '')
    : parseISO(route.query.startsAt);

  const endsAt = Array.isArray(route.query.endsAt)
    ? parseISO(route.query.endsAt[0] || '')
    : parseISO(route.query.endsAt);

  const locationsPositionId = typeof route.query.locationsPositionId === 'string'
    ? parseInt(route.query.locationsPositionId, 10)
    : Number.NaN;

  const employmentId = typeof route.query.employmentId === 'string'
    ? parseInt(route.query.employmentId, 10)
    : Number.NaN;

  return ({
    startsAt: isValid(startsAt) ? startsAt : undefined,
    endsAt: isValid(endsAt) ? endsAt : undefined,
    shiftplanId: parseInt(route.params.shiftplanId, 10),
    locationsPositionId: !Number.isNaN(locationsPositionId) ? locationsPositionId : undefined,
    employmentId: !Number.isNaN(employmentId) ? employmentId : undefined,
  });
};

const routes: RouteConfig[] = [
  {
    component: CalendarDialogShiftContainer,
    path: 'shifts/:id(\\d+)',
    props: (route: RouteType) => ({
      shiftId: Number.parseInt(route.params.id, 10),
      shiftplanId: Number.parseInt(route.params.shiftplanId, 10),
    }),
    children: [
      {
        name: Route.ROOT,
        component: DetailsContainer,
        path: '',
        meta: {
          hasTabsHidden: false,
          hasEditButton: true,
          hasDeleteButton: true,
        },
      },
      {
        component: Paygrades,
        name: Route.TAB_PAYGRADES,
        path: 'paygrades',
        meta: {
          hasSaveButton: true,
        },
      },
      {
        component: Employees,
        name: Route.TAB_EMPLOYEES,
        path: 'employees',
      },
      {
        component: JoinShift,
        name: Route.TAB_JOIN_SHIFT,
        path: 'join-shift',
      },
      {
        component: LeaveShift,
        name: Route.TAB_LEAVE_SHIFT,
        path: 'leave-shift',
      },
      {
        component: ReplaceRequests,
        name: Route.TAB_REPLACE_REQUESTS,
        path: 'replace-requests',
      },
      {
        component: Evaluations,
        name: Route.TAB_EVALUATION,
        path: 'evaluation',
      },
    ],
  },
  {
    component: CalendarDialogShiftContainer,
    path: 'shifts/new',
    props: (route: RouteType) => ({
      shiftplanId: parseInt(route.params.shiftplanId, 10),
    }),
    children: [
      {
        name: Route.DIALOG_NEW,
        component: DetailsContainer,
        path: '',
        props: propsInjectorDialogNew,
        meta: {
          hasTabsHidden: true,
          hasSaveButton: true,
        },
      },
    ],
  },
];

export default routes;
